let incomingCallAnsweredHandler = null;

export function setVoiceIncomingCallAnsweredHandler(handler) {
  incomingCallAnsweredHandler = typeof handler === 'function' ? handler : null;
}

export function clearVoiceIncomingCallAnsweredHandler() {
  incomingCallAnsweredHandler = null;
}

export function notifyVoiceIncomingCallAnswered() {
  incomingCallAnsweredHandler?.();
}
